import { type UseQueryOptions, useQuery } from 'react-query';

import { queryKeys } from 'src/services/api/constants';
import { apiClient } from 'src/services/api/client';
import { legacyFeatureFlags } from 'src/utils/legacy-feature-flags';

export const useStripeClientSecret = (options?: Pick<UseQueryOptions, 'enabled'>) => {
    return useQuery(
        [queryKeys.stripeClientSecret],
        async () => {
            if (legacyFeatureFlags.billing) {
                const res = await apiClient('api/landlord/billing/pricing-table-client-secret')
                    .json<{ client_secret: string; }>();
                return res.client_secret;

            } else {
                return null;
            }
        },
        {
            ...options,
        }
    );
};
